// Shared frontend governance copy — keep in sync with backend/governance.py + report.py.
// Used as a fallback when a report predates governance injection (sections.disclaimer etc).
export const DISCLAIMER_TEXT =
  "This assessment is a resilience readiness tool, not a Business Continuity Plan. It does not " +
  "confer ISO 22301 or equivalent compliance and does not constitute legal, regulatory, or " +
  "certification advice. Use it to improve your thinking — then engage qualified professionals " +
  "to validate, test, and maintain your arrangements.";

export const SCORE_CAVEAT_TEXT =
  "This score reflects the controls you described, not controls that have been independently " +
  "tested or verified. An untested control is not a confirmed control. A higher score does not " +
  "mean your business is prepared — it means more indicators were present in your responses.";

export const DEFAULT_CTA = {  heading: "Where to go from here",
  items: [
    {
      title: "Resilience Action Session (60 minutes)",
      description:
        "For owners who want to work through these findings with expert support and leave with a prioritised set of next moves.",
    },
    {
      title: "Resilience Workshop",
      description:
        "For those who lead a team and want a facilitated group conversation that turns this assessment into shared, owned actions.",
    },
    {
      title: "SME Resilience Retainer",
      description:
        "For owners who want the full package: assessment, debrief, a written action plan, and a 90-day follow-up.",
    },
  ],
};


// Single source of truth for the paid Workshop copy — used by both the public
// Plans & Pricing page and the in-app "Book a workshop" modal so they never drift.
// The PRICE + price-label come from the Admin catalog (config.flat_advisory_*).
export const WORKSHOP_TITLE = "Biz Resilience Workshop";
export const WORKSHOP_HEADLINE =
  "A 3-hour working session with a senior Biz Resilience practitioner, for teams of up to 10";
export const WORKSHOP_DESC =
  "Walk through your preliminary scan results together, prioritise the gaps that matter, and leave with a sharpened one-page summary and concrete next steps your team can actually execute.";
